import { InnerBox } from "@/components/elements/InnerBox";
import { DATE_FORMAT } from "@/constants/datetime";
import { MatchInfoItem } from "@/features/match/components/match-info/MatchInfoItem";
import { TMatchInfo } from "@/features/match/types/MatchInfo";
import { black } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Grid, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

type TMatchJobIntroductionManagerInfoProps = {
  defaultValues: Partial<TMatchInfo>;
};

export const MatchJobIntroductionManagerInfo: FCC<TMatchJobIntroductionManagerInfoProps> = ({ defaultValues }) => {
  const matchOffices = defaultValues?.matchOffices || [];
  const MATCH_OFFICE_COUNT = 3;

  return (
    <InnerBox showDivider={false} padding={3}>
      <Stack alignItems="flex-start">
        <Typography variant="head20Bold" color={black[30]}>
          職業紹介責任者情報
        </Typography>

        <Grid mt={2} container columnSpacing={3} rowSpacing={1}>
          {Array.from({ length: MATCH_OFFICE_COUNT }, (_, i) => {
            const matchOffice = matchOffices[i];
            const isLastRow = i === MATCH_OFFICE_COUNT - 1;

            return (
              <Grid key={`responsible-person-${i}`} item xs={12} container columnSpacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <MatchInfoItem label={`${i + 1}. 事業所名`} value={matchOffice?.officeName || "-"} isShowDivider={!isLastRow} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <MatchInfoItem label="氏名" value={matchOffice?.fullName || "-"} isShowDivider={!isLastRow} />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <MatchInfoItem
                    label="講習受講日"
                    value={
                      matchOffice?.trainingDate && dayjs(matchOffice.trainingDate).isValid()
                        ? dayjs(matchOffice.trainingDate).format(DATE_FORMAT)
                        : null
                    }
                    isShowDivider={!isLastRow}
                  />
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </InnerBox>
  );
};
